import { useMemo } from 'react';

import { type Region, type ServiceMeta, useKeywordMetadata } from '@kc-console/context';
import { StatusServiceKeyword } from '@kc-console/guard';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { HelpdeskMenuItem } from '@/shared/lib/keywordVariableParsing';

import {
  HELPDESK_VARIABLE_KEY,
  parseHelpdeskMenuVariableValue,
} from '@/shared/lib/keywordVariableParsing';

export type { HelpdeskMenuItem } from '@/shared/lib/keywordVariableParsing';

export type UseHelpdeskMenuOptions = UseQueryOptions<ServiceMeta>;

export type UseHelpdeskMenuResult = {
  helpdeskMenuItems: HelpdeskMenuItem[];
};

const useHelpdeskMenu = (
  region?: Region,
  options?: UseHelpdeskMenuOptions,
): UseHelpdeskMenuResult => {
  const { data: keywordMetadata } = useKeywordMetadata(StatusServiceKeyword, region, options);

  const helpdeskMenuItems = useMemo(() => {
    const raw = keywordMetadata?.variables?.[HELPDESK_VARIABLE_KEY];
    return parseHelpdeskMenuVariableValue(raw) ?? [];
  }, [keywordMetadata?.variables]);

  return { helpdeskMenuItems };
};

export default useHelpdeskMenu;
